﻿ ﻿//constants
export const windowWidth: number = 1024;
export const windowHeight: number = 768;
// Injected at build time by Vite's `define` from VITE_GAME_VERSION (the Azure
// pipeline's counter supplies major.minor.build; falls back to 0.0.0-dev
// locally). To bump the version, change majorMinor in azure-pipelines.yml.
declare const __APP_VERSION__: string;
export const GAME_VERSION: string = __APP_VERSION__;
export const shipDrag: number = 100;
export const shipAcceleration: number = 300;
export const shipMaxVelocity: number = 300;
export const shipAngularVelocity: number = 200;
// How bouncy the ship is off asteroids: 1 = fully elastic (like the original),
// 0 = no bounce. Affects only the velocity component into the asteroid.
export const shipBounceRestitution: number = 1;
// Bounciness of asteroid-vs-asteroid collisions (1 = elastic).
export const asteroidRestitution: number = 1;
// Minimum impact speed (relative, along the contact normal) for an asteroid to
// damage an enemy ship - so a solid hit hurts but a gentle graze just bounces.
export const asteroidEnemyDamageSpeed: number = 70;
// How readily an enemy ship can shove an asteroid it drives into. Scaled by
// 1/mass, so a small rock is pushed aside easily and a big one resists. The
// shove can never make the rock outrun the enemy itself, so a chasing enemy
// nudges rocks out of its way instead of pumping speed into them.
export const enemyAsteroidPush: number = 1;
export const laserLifespan: number = 2000;
export const laserSpeed: number = 600;
export const laserGap: number = 250;
// Background music volume (0-1), kept low so it sits under the sound effects.
export const musicVolume: number = 0.4;
export const stationSize: number = 364;
export const shieldDuration: number = 500;
export const asteroidClearRadius: number = 250;

//constants for asteroids
export const asteroidClass =
[
    {
        MinAngularVelocity: 0,
        MaxAngularVelocity: 100,
        MinVelocity: 0,
        MaxVelocity: 75,
        Mass: 2
    },
    {
        MinAngularVelocity: 0,
        MaxAngularVelocity: 10,
        MinVelocity: 0,
        MaxVelocity: 40,
        Mass: 8
    }
];

export const bigAsteroidChance: number = 0.1;

//constants for enemies
export const enemyClass =
[
    {
        Explode: [0, 1, 2, 3, 4, 5, 6, 7],
        Speed: 100,
        FireSpeed: 200,
        FireGap: 2000,
        FireKey: 'enemyfire',
        FireSound: 'enemyfire',
        ViewDistance: 500,
        FollowDistance: 300,
        Shield: 2,
        Count: 1,
        Increase: 0.5,
        ClearRadius: 550
    },
    {
        Explode: [0, 5, 6, 7, 8, 9, 10, 11],
        Speed: 200,
        FireSpeed: 400,
        FireGap: 1000,
        FireKey: 'bluelaser',
        FireSound: 'enemylaser',
        ViewDistance: 700,
        FollowDistance: 450,
        Shield: 1,
        Count: -1,
        Increase: 0.5,
        ClearRadius: 750
    }
];

//constants for level set up
export const worldWidth: number = 2000;
export const worldHeight: number = 2000;
export const worldIncrease: number = 250;
export const maxWorldSize: number = 6000;
export const asteroidDensity: number = 133333;
export const asteroidDensityDecrease: number = 1000;
export const asteroidMinDensity: number = 113333;

export interface LaserImage extends Phaser.Physics.Arcade.Image {
    removeTimer?: Phaser.Time.TimerEvent;
}
